export * from './card-config.interface';
